import * as angular from 'angular';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, Alert, ApplicationsResource) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.Alert = Alert;
        this.ApplicationsResource = ApplicationsResource;
    }

    $onInit() {
        this.$selectedRoles = this.groups.reduce((groupIds, group) => ({
            ...groupIds,
            [group.id]: this.application.loginRoles.reduce((roleIds, {loginRoleId}) => (
                {...roleIds, [loginRoleId]: group.appRoleIds.includes(loginRoleId)}
            ), {})
        }), {});

        this.selectedRoles = angular.copy(this.$selectedRoles);
        this.managePasswordsVisible=this.application.passwordAuthenticationEnabled || (this.application.adAccountPasswordsCanBeEdited && this.application.adAccountPasswordsCanBeViewed && (this.is('computer-login') || this.is('ad-password-manager')));
    }

    is(...types) {
        return types.includes(this.application.applicationType.slug);
    }

    resetRoles() {
        this.selectedRoles = angular.copy(this.$selectedRoles);
    }

    rolesNotModified() {
        return angular.equals(this.$selectedRoles, this.selectedRoles);
    }

    selectedRoleNamesForGroup(groupId) {
        return this.selectedRolesForGroup(groupId)
            .map((role) => role.loginRoleName)
            .join(', ')
    }

    selectedRolesForGroup(groupId) {
        return this.application.loginRoles
            .filter((role) => this.selectedRoles[groupId][role.loginRoleId])
    }

    showUnassignGroupModal(groupId) {
        this.$uibModal
            .open({
                component: 'companyManageApplicationUsersUnassignGroup',
                resolve: {
                    applicationId: () => this.application.id,
                    companyId: () => this.companyId,
                    groupId: () => groupId,
                },
            }).result
            .then(() => {
                const index = this.groups.findIndex(({id}) => id === groupId);
                this.groups.splice(index, 1);
                this.Alert('success', 'company.manage-application.users.unassign-group.unassigned');
            })
    }

    showEpmCredentialsModal(groupId) {
        this.$uibModal
            .open({
                component: 'companyManageApplicationUsersEpmCredentials',
                resolve: {
                    applicationId: () => this.application.id,
                    companyId: () => this.companyId,
                    groupId: () => groupId,
                },
                size:'xl',
            })
    }

    showManagePasswordsModal(groupId) {
        this.$uibModal
            .open({
                component: 'companyManageApplicationUsersManagePasswords',
                resolve: {
                    applicationId: () => this.application.id,
                    companyId: () => this.companyId,
                    groupId: () => groupId,
                    isComputerApplication: () => this.is('computer-protection-without-ad','computer-login'),
                    isAdPasswordManagerApplication: () => this.is('ad-password-manager'),
                    adPasswordViewSupported: () => this.application.adAccountPasswordsCanBeViewed,
                    isAdPassEditableApplication: () => this.application.adAccountPasswordsCanBeEdited && (this.is('computer-login') || this.is('ad-password-manager')),
                },
                size:'xl',
            })

    }

    updateAwsGroupRoles() {
        const data = this.groups.map((group) => ({
            groupId: group.id,
            roleIds: this.selectedRolesForGroup(group.id).map((role) => role.loginRoleId),
        }));

        this.isSavingRoles = true;
        this.ApplicationsResource
            .updateAwsGroupRoles(this.companyId, this.application.id, data)
            .then(() => this.$state.reload('company.manage-application'))
            .then(() => this.Alert('success', 'company.manage-application.users.saved-roles'))
            .finally(() => this.isSavingRoles = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/assigned-groups/assigned-groups.controller.js